import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { pdf } from "@react-pdf/renderer";
import {
  Button,
  Offcanvas,
  OverlayTrigger,
  Tooltip,
  Dropdown,
  Row,
  Col,
  Tabs,
  Tab,
  Card,
} from "react-bootstrap";
import "./View_DetailsOpportunity.css";
import {
  IconCalendarWeek,
  IconChevronDown,
  IconCopy,
  IconChevronRight,
  IconCopyCheck,
  IconEdit,
  IconFileTypePdf,
  IconPhoto,
  IconMail,
  IconMapPin,
  IconPaperclip,
  IconPhone,
  IconLink,
  IconShare,
  IconUser,
  IconFileTypeDoc,
  IconClockHour3,
  IconUserCircle,
  IconRefreshDot,
  IconEye,
  IconCreditCardPay,
} from "@tabler/icons-react";
import moment from "moment";
import { Link, useNavigate, useParams } from "react-router-dom";
import KOorCustomerEmailDialog from "../Email/KOorCustomerEmailDialog";
import SuccsessMsgModal from "../../../components/SuccessMsgModal";
import CardDetails from "../CardDetails/CardDetails";
import CopyOpportunityDialog from "../CopyOpportunity/CopyOpportunityDialog";
import ComanConfirmationModal from "../../../components/ComanConfirmationModal";
import usePostRequest from "../../../hooks/usePostRequest";
import { API_ENDPOINTS, truncateFormat } from "../../../constant/_constant";
import { toast } from "react-toastify";
import Lottie from "lottie-react";
import CreateOrder from "../OrderPopup/CreateOrder";
import notfoundData from "../../../assets/not_found.json";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import CreateOrderEditRfq from "../OrderPopup/CreateOrderEditRfq";
import RfqWonPopup from "../EditWonInfo/RfqWonPopup";
import { trimTrailingZeros } from "../../../utils/_helpers";
import { usePostHog } from "@posthog/react";
import PdfDocument from "../PDF/main";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const IMG = process.env.REACT_APP_BASE_URL_IMG;
const items = [
  "Item 1",
  "Item 2",
  "Item 3",
  "Item 4",
  "Item 5",
  "Item 6",
  "Item 7",
  "Item 8",
  "Item 9",
];

const ITEMS_PER_VIEW = 3.5;

const generateUniqueId = () => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  let result = "";
  for (let i = 0; i < 8; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters.charAt(randomIndex);
  }

  const timestamp = Date.now().toString();
  const uniqueId = result + timestamp.slice(-4);
  return uniqueId;
};

function View_DetailsOpportunity({
  // show,
  // setShow,
  // opportunity,
  isStatusUpdate,
  onStatusUpdate,
  triggerCardHighlight,
}) {
  const STATUS_TRANSITIONS = {
    DRAFT: ["PENDING", "PAYMENT_SUCCESSFUL", "WON", "LOST", "CANCELLED"],
    PENDING: ["PAYMENT_SUCCESSFUL", "WON", "LOST", "CANCELLED"],
    PAYMENT_SUCCESSFUL: ["WON", "LOST", "CANCELLED"],
    WON: ["LOST", "CANCELLED"],
    LOST: ["CANCELLED"],
    CANCELLED: [],
  };

  const statusOptions = [
    { value: "PENDING", label: "Pending", color: "#f4a100" },
    // {
    //   value: "PAYMENT_SUCCESSFUL",
    //   label: "Payment Successful",
    //   color: "#23af6eff",
    // },
    { value: "WON", label: "Won", color: "#28a745" },
    { value: "LOST", label: "Lost", color: "#dc3545" },
    { value: "CANCELLED", label: "Cancelled", color: "#dc3545" },
    { value: "DRAFT", label: "Draft", color: "#818183ff" },
  ];

  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const allowedRoles = ["super-admin", "business-development", "finance"];
  const canViewFinancials = user?.roles?.some((role) =>
    allowedRoles.includes(role),
  );
  const [opportunity, setOpportunity] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    action: null,
    message: "",
  });

  const [formId, setFormId] = useState(null);

  useEffect(() => {
    const newFormId = generateUniqueId();
    setFormId(newFormId);
    // reset();
  }, []);

  const posthog = usePostHog();
  const [showCardDetails, setShowCardDetails] = useState(false);
  const openCardDetails = () => setShowCardDetails(true);
  const closeCardDetails = () => setShowCardDetails(false);
  const [show, setShow] = useState(false); // Local state to control the popup
  const [showCreateOrder, setShowCreateOrder] = useState(false);
  const [WonRfqID, setWonRfqID] = useState("");
  const KoEmail = opportunity?.rfqKo?.email || "";
  const [errorRfq, setErrorRfq] = useState("");
  const [showCreateOrderRfq, setShowCreateOrderRfq] = useState(false);
  const [createOrderRfqId, setCreateOrderRfqId] = useState(null);
  const [showAddVendor, setShowAddVendor] = useState(false);
  const [errorProducts, setErrorProducts] = useState([]);

  // console.log("opportunity data", opportunity);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const rfqId = searchParams.get("rfq_id");

  // console.log("rfqId from query params:", rfqId);

  // console.log("Full URL:", window.location.href);
  // console.log("location.search:", window.location.search);

  const { data: fetchedOpportunity, postData: fetchOpportunity } =
    usePostRequest(API_ENDPOINTS.GET_SINGLE_RFQ);

  useEffect(() => {
    if (window.location.search) {
      const searchParams = new URLSearchParams(window.location.search);
      const rfqId =
        searchParams.get("rfq_id") ||
        window.location.search.slice(1).split("&")[0];
      if (rfqId) {
        fetchOpportunity({ rfq_id: rfqId, route_type: "rfq" });
      }
    }
  }, [window.location.search]);

  useEffect(() => {
    if (fetchedOpportunity?.data) {
      setOpportunity(fetchedOpportunity.data);
      setShow(true);
    }
  }, [fetchedOpportunity]);

  const handleClose = () => {
    setShow(false);
    const newUrl = window.location.pathname;
    window.history.pushState(null, "", newUrl);
  };

  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(statusOptions[0]);

  const [isSuccsessModalOpen, setIsSuccsessModalOpen] = useState({
    show: false,
    message: "",
    btntext: "Close",
    title: "Succsess",
    newbtn: "",
  });

  const handleSelect = (option) => {
    setSelected(option);
    setIsOpen(false);
  };

  const { isLoading: removeLoading, postData: statusChange } = usePostRequest(
    API_ENDPOINTS.OPPORTUNITY_STATUS,
  );

  const { loadingdownLoad, postData: DownLoadFile } = usePostRequest(
    API_ENDPOINTS.DownLoadFile,
  );

  const { isLoading: createLoading, postData: createRFQCopy } = usePostRequest(
    API_ENDPOINTS.COPY_RFQ,
  );

  const { data: fetchLink, postData: GetAttachment } = usePostRequest(
    API_ENDPOINTS.VIEW_ATTACHMENTS,
  );

  const onStatusSuccess = (response) => {
    toast.success(response.message);
    if (response.rfq_status === "WON") {
      console.log(
        "The opportunity ",
        response.rfq_id,
        " has been changed to ",
        response.rfq_status,
      );
      setWonRfqID(response.rfq_id);
      setShowCreateOrder(true);
      posthog.capture("opportunity_moved_won", {
        moved_by: user?.email,
        rfq_id: response?.rfq_id,
      });
    }
    setShow({ isStatusUpdate: true });
    if (onStatusUpdate) {
      onStatusUpdate();
    }
    triggerCardHighlight(response?.rfq_id);
    handleClose();
  };

  const onStatusError = (error) => {
    toast.error(error.message || "An error occurred during Status Change.");
    if (error?.products && error?.products?.length > 0) {
      setShowAddVendor(true);
      setErrorProducts(error?.products);
      setErrorRfq(error?.rfq_id);
    }
  };

  // const downloadImage = (e, file_name) => {
  //   e.preventDefault();
  //   const imageUrl = `${BASE_URL}/common/download/${file_name}`;

  //   const link = document.createElement("a");
  //   link.href = imageUrl;
  //   link.setAttribute("download", "image.jpg");
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  useEffect(() => {
    if (fetchLink?.data) {
      window.open(fetchLink.data, "_blank");
    }
  }, [fetchLink]);

  const viewAttachment = async (e, attachmentId) => {
    e.preventDefault();
    try {
      await GetAttachment({ id: attachmentId });
    } catch (error) {
      console.error("Failed to view attachment", error);
    }
  };

  const downloadImage = async (e, item) => {
    e.preventDefault();

    try {
      const res = await GetAttachment({ id: item?.id });

      console.log("resres", fetchLink);

      const fileUrl = fetchLink?.data; // this is the returned URL
      if (!fileUrl) return;

      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = item?.original_name || "";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const handleShareClick = () => {
    const baseUrl = window.location.origin;
    // const fullUrl = `${baseUrl}/aspettoportal_dev/frontend/edit-rfq/${opportunity?.rfq_id}`;
    const fullUrl = `${baseUrl}/list-opportunities?${opportunity?.rfq_id}`;

    // Check if the Clipboard API is available
    if (navigator.clipboard) {
      // Clipboard API is available, use it
      navigator.clipboard
        .writeText(fullUrl)
        .then(() => {
          // console.log("Link copied to clipboard");
          toast.success("Link copied to clipboard");
        })
        .catch((error) => {
          console.error("Failed to copy: ", error);
        });
    } else {
      // Fallback: Use a temporary textarea to copy text for browsers that do not support Clipboard API
      const textarea = document.createElement("textarea");
      textarea.value = fullUrl;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);

      toast.success("Link copied to clipboard");
    }
  };

  const ChangeStatusHandler = (rfqid, status) => {
    statusChange(
      { rfq_id: rfqid, rfq_status: status },
      onStatusSuccess,
      onStatusError,
    );
  };

  const openModal = (rfqid, status, Old_Status) => {
    let modalMessage = `Are you sure you want to change status to "${Old_Status} to ${status}"`;
    let modalTitle = "Change Status";
    let type = "success";
    let modalIcon = <IconRefreshDot stroke={1} />;
    let actionHandler = () => {
      ChangeStatusHandler(rfqid, status);
    };
    let action = "Change";
    setIsModalOpen({
      show: true,
      action,
      message: modalMessage,
      onConfirm: actionHandler,
      title: modalTitle,
      icon: modalIcon,
      type: type,
    });
  };

  const onSuccess = (res) => {
    setIsSuccsessModalOpen({
      show: true,
      title: `Opportunity Created Successfully in ${`PENDING`}!`,
      message: `Created by ${user?.first_name} ${
        user?.last_name
      }. Opportunity ID is 
                      <strong style="color: orange;">${
                        res.rfq_id
                      }</strong>. This opportunity is for ${
                        res?.contract_type
                      }. Created on ${moment(res?.created_date).format("MM/DD/YYYY")}.`,
      btntext: "Return Home",
      newbtn: "Create New Opportunity",
      // show: true,
      // title: "Opportunity Created Successfully!",
      // message: `Prepared by Opportunity ID is ${
      //   res.rfq_id
      // }. This opportunity is for ${res?.contract_type}. Created on ${moment(
      //   res?.created_date
      // ).format("MM/DD/YYYY")}.`,
      // btntext: "Return Home",
    });
    if (onStatusUpdate) {
      onStatusUpdate();
    }
    handleClose();
  };

  const onError = (err) => {
    toast.error(err?.message || "Failed to duplicate Opportunity.");
  };

  const CopyOpportunityHandler = (opportunity) => {
    // console.log("opportunity", opportunity);
    const payload = {
      // attachment_id: formId,
      rfq_id: opportunity?.rfq_id || null,
      // opportunity_type: opportunity?.opportunity_type || null,
      // order_type: opportunity?.order_type || null,
      // order_payment_type: opportunity?.order_payment_type || null,
      // opportunity_name: opportunity?.opportunity_name || null,
      // custom_fields: opportunity?.custom_fields || [],
      // initial_consolidation: Number(opportunity?.initial_consolidation || 0),
      // contract_type_id: Number(opportunity?.contract_type_id || 0),
      // published_date: moment().format("YYYY-MM-DD"),
      // sales_lead_username: opportunity?.sales_lead_username || null,
      // sales_lead_name: opportunity?.sales_lead_name || null,
      // sales_lead_email: opportunity?.sales_lead_email || null,
      // sales_lead_phone: opportunity?.sales_lead_phone || null,
      // organization_name: opportunity?.organization_name || null,
      // brief: opportunity?.brief || null,
      // estimated_delivery: opportunity?.estimated_delivery || null,
      // payment_term: opportunity?.payment_term || null,
      // shipping_method: opportunity?.shipping_method || null,
      // shipping_method_detail: opportunity?.shipping_method_detail || null,
      // shipping_term: opportunity?.shipping_term || null,
      // valid_for: opportunity?.valid_for || null,
      // is_draft: true,
      // shipping_cost: opportunity?.shipping_cost
      //   ? Number(opportunity.shipping_cost)
      //   : "0.00",
      // tax: opportunity?.tax || "0.00",
      // ko_detail: {
      //   name: opportunity?.rfqKo?.name || null,
      //   email: opportunity?.rfqKo?.email || null,
      //   phone: opportunity?.rfqKo?.phone || null,
      //   address: opportunity?.rfqKo?.address || null,
      // },
      // shipping_detail: {
      //   name: opportunity?.rfqShipping?.name || null,
      //   email: opportunity?.rfqShipping?.email || null,
      //   phone: opportunity?.rfqShipping?.phone || null,
      //   address: opportunity?.rfqShipping?.address || null,
      // },
      // billing_detail: {
      //   name: opportunity?.rfqBilling?.name || null,
      //   email: opportunity?.rfqBilling?.email || null,
      //   phone: opportunity?.rfqBilling?.phone || null,
      //   address: opportunity?.rfqBilling?.address || null,
      // },
      // status: "DRAFT",
      // otherCost: Array.isArray(opportunity?.other_cost_json)
      //   ? opportunity.other_cost_json
      //   : JSON.parse(opportunity?.other_cost_json || "[]"),
      // products: (opportunity?.RfqProducts || []).map((product) => ({
      //   vendor_name: product.Vendor?.display_name || null,
      //   sku_id: product.sku_display_name, // changed from sku_id to sku_display_name
      //   description: product.description || null,
      //   sku_display_name: product.sku_id || null,
      //   name: product.name || null,
      //   purchase_description: product.purchase_description || null,
      //   quantity: Number(product.quantity || 0),
      //   aspetto_price: Number(product.aspetto_price || 0),
      //   customer_price: Number(product.customer_price || 0),
      //   margin_percent: Number(product.margin_percent || 0),
      //   total_price: Number(product.total_price || 0),
      //   um: product.um || product.unit_of_measure || null,
      // })),
      // total_cost_before_margin: opportunity?.total_cost_before_margin
      //   ? Number(opportunity.total_cost_before_margin)
      //   : null,
      // total_cost_after_margin: opportunity?.total_cost_after_margin
      //   ? Number(opportunity.total_cost_after_margin)
      //   : null,
    };
    // console.log("payload",payload)
    createRFQCopy(payload, onSuccess, onError);
  };

  const openModalCopy = (opportunity) => {
    let modalMessage = `Are you sure you want to duplicate this "${opportunity?.rfq_id}" opportunity?`;
    let modalTitle = "Duplicate Opportunity";
    let type = "success";
    let modalIcon = <IconCopy stroke={1} />;
    const rfqId = opportunity?.rfq_id;
    let actionHandler = () => {
      // CopyOpportunityHandler(opportunity);
      navigate("/create-rfq", { state: { rfqId } });
    };
    let action = "Change";
    setIsModalOpen({
      show: true,
      action,
      message: modalMessage,
      onConfirm: actionHandler,
      title: modalTitle,
      icon: modalIcon,
      type: type,
    });
  };

  useEffect(() => {
    if (opportunity?.status) {
      const match = statusOptions.find(
        (opt) => opt.value === opportunity.status,
      );
      if (match) {
        setSelected(match);
      }
    }
  }, [opportunity]);

  /*swiper*/

  /*swiper*/

  const handleOpenKOorCustomerEmailOpenDialog = (e) => {
    e.preventDefault();
    setIsEmaillOpen({ show: true });
  };

  const [isCopyQuoteOpen, setIsCopyQuoteOpen] = useState({
    show: false,
    Feild: "",
    rfq_id: "",
    btnText: "",
    label: "",
  });

  // const handleCopy_Quote = (selectedOption, rfq_id) => {
  //   navigate("/copy-quote", {
  //     state: {
  //       selectedCopy: selectedOption,
  //       rfqCopy: rfq_id,
  //     },
  //   });
  // };

  const [isEmaillOpen, setIsEmaillOpen] = useState({
    title: "",
    show: false,
    row: "",
    skuData: "",
    defaultSubject: "",
    Quote_No: "",
    RFQID: "",
    toEmail: "",
    toName: "",
  });

  const totalNotes = opportunity?.section.reduce((acc, section) => {
    return acc + section.notes.length;
  }, 0);

  const handleModalClose = () => {
    setShow({ show: false });
    navigate("/list-opportunities");
  };

  useEffect(() => {
    window.onPaymentSuccess = () => {
      handleClose(); // This closes the entire Offcanvas!
    };

    return () => {
      delete window.onPaymentSuccess;
    };
  }, [opportunity?.rfq_id]);

  const handleWonSuccess = (rfqId) => {
    console.log("createOrderRfqId", createOrderRfqId);
    setCreateOrderRfqId(rfqId);
    setShowCreateOrderRfq(true);
  };

  const PD = new Date();
  const today = new Intl.DateTimeFormat("en-US", {
    dateStyle: "medium",
  }).format(PD);
  const HandlePDFClick = async () => {
    const OP_arr = String(`Quote`).split(".");
    for (var i = 0; i < OP_arr.length; i++) {
      OP_arr[i] = OP_arr[i].charAt(0).toUpperCase() + OP_arr[i].slice(1);
    }

    const sanitizeAddress = (address) => {
      if (!address) return [];
      return address
        .split("\n") // split by newline
        .map((line) => line.replace(/\t+/g, " ").trim()) // replace tabs with space, trim
        .filter((line) => line.length > 0);
    };

    const updatedInvoiceData = {
      // ...InvoiceData,
      invoice_num: String(opportunity.rfq_id),
      Contract_Vehicle: opportunity.ContractType.name,
      KO_name: opportunity.rfqKo.name,
      KO_email: opportunity.rfqKo.email,
      KO_phone: opportunity.rfqKo.phone,
      KO_address: sanitizeAddress(opportunity.rfqKo.address),
      Print_Date: String(today),
      trans_date: String(opportunity.updated_at).split("T")[0],
      due_date: opportunity.due_date,
      Valid_For: opportunity.valid_for,
      Address:
        "ASPETTO INC, 150 Riverside pkwy. Suite 203. Fredericksburg, VA 22406 USA",
      items: opportunity.RfqProducts,
      Tax: opportunity.tax,
      Shipping_Cost: opportunity.shipping_cost,
      Total_Cost: opportunity.total_cost_after_margin,
      Other_Cost: opportunity.other_cost_json,
      BillTo_Phone: opportunity.rfqBilling.phone,
      BillTo_Name: opportunity.rfqBilling.name,
      BillTo_Address: sanitizeAddress(opportunity.rfqBilling.address),
      BillTo_Email: opportunity.rfqBilling.email,
      Notes: opportunity.RfqNotes,
      Shipping_Details: {
        Organization_Name: opportunity.organization_name,
        KO_name: opportunity.rfqKo.name,
        Sales_Head_Info: {
          Name: opportunity.sales_lead_name, //formatStringKey
          Email: opportunity.sales_lead_email,
          Phone: opportunity.sales_lead_phone,
        },
        Customer_Name: opportunity.rfqShipping.name, // formatStringKey
        Customer_Email: opportunity.rfqShipping.email,
        Customer_Phone: opportunity.rfqShipping.phone,
        Customer_Address: sanitizeAddress(opportunity.rfqShipping.address),
        Shipping_Method: opportunity.shipping_method,
        Shipping_Method_Detail: opportunity.shipping_method_detail,
        Shipping_Terms: opportunity.shipping_term,
        Estimated_Delivery: opportunity.estimated_delivery,
        Payment_Terms: opportunity.payment_term,
        Payment_Terms_Details: opportunity.payment_term_detail,
      },
    };

    // setInvoiceData(updatedInvoiceData);
    //  Format Opportunity Name for file name
    let File_Opportunity_Name = "";

    File_Opportunity_Name = OP_arr.join(" ");

    setTimeout(async () => {
      try {
        console.log("1. Starting PDF generation");
        console.log("2. updatedInvoiceData:", updatedInvoiceData);
        console.log("3. items count:", updatedInvoiceData.items?.length);
        console.log(
          "4. Tax:",
          updatedInvoiceData.Tax,
          "Shipping:",
          updatedInvoiceData.Shipping_Cost,
        );
        console.log("5. Other_Cost raw:", updatedInvoiceData.Other_Cost);
        console.log("6. Total_Cost:", updatedInvoiceData.Total_Cost);
        console.log(
          "7. Shipping_Details:",
          updatedInvoiceData.Shipping_Details,
        );
        console.log("8. KO_name:", updatedInvoiceData.KO_name);
        console.log("9. BillTo_Name:", updatedInvoiceData.BillTo_Name);

        const pdfBlob = await pdf(
          <PdfDocument invoicedata={updatedInvoiceData} />,
        ).toBlob();

        console.log("10. PDF blob generated successfully");

        const url = URL.createObjectURL(pdfBlob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${File_Opportunity_Name} ${String(opportunity.rfq_id).split(".")[0]}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } catch (err) {
        console.error("PDF FAILED AT:", err);
        console.error("Error stack:", err.stack);
      }
    }, 0);
    // setTimeout(async () => {
    //   // setLoading(true);
    //   const pdfBlob = await pdf(
    //     <PdfDocument invoicedata={updatedInvoiceData} />,
    //   ).toBlob();

    //   const url = URL.createObjectURL(pdfBlob);

    //   const a = document.createElement("a");
    //   a.href = url;
    //   a.download = `${File_Opportunity_Name} ${String(row.rfq_id).split(".")[0]
    //     }.pdf`;
    //   document.body.appendChild(a);
    //   console.log("2", a.download);
    //   a.click();
    //   document.body.removeChild(a);
    //   URL.revokeObjectURL(url);
    // }, 0);
  };

  return (
    <>
      <RfqWonPopup
        show={showAddVendor}
        onClose={() => setShowAddVendor(false)}
        products={errorProducts}
        rfqId={errorRfq}
        onWonSuccess={handleWonSuccess}
      />
      <CreateOrderEditRfq
        show={showCreateOrderRfq}
        onClose={() => {
          setShowCreateOrderRfq(false);
          setCreateOrderRfqId(null);
        }}
        rfqId={createOrderRfqId}
      />
      <CardDetails
        show={showCardDetails}
        onClose={closeCardDetails}
        emailId={KoEmail}
        paymentAmount={opportunity?.total_cost_after_margin}
        opportunityId={opportunity?.rfq_id}
        invoiceNo={opportunity?.rfq_id}
      />
      <CreateOrder
        show={showCreateOrder}
        onClose={() => setShowCreateOrder(false)}
        rfqId={WonRfqID}
      />
      <Offcanvas
        name="Detail"
        show={show}
        // onHide={handleClose}
        // onHide={() => setShow({ show: false })}
        // onHide={handleModalClose}
        onHide={handleClose}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className="flex_profit_row">
              {canViewFinancials && (
                <>
                  <p className="mb-0">
                    <span className="profit_est">Est. Profit:</span> $
                    {(() => {
                      const after = Number(
                        opportunity?.total_cost_after_margin,
                      );
                      const before = Number(
                        opportunity?.total_cost_before_margin,
                      );
                      const profit = after - before;
                      const percentage =
                        after !== 0 ? (profit / after) * 100 : 0;
                      return `${truncateFormat(profit, 2)} (${truncateFormat(
                        percentage,
                        2,
                      )}%)`;
                    })()}
                  </p>
                  <p className="mb-0 mt-0">
                    <span className="profit_est">Est. Expenses:</span> $
                    {Number(opportunity?.total_cost_before_margin)}
                  </p>
                </>
              )}
            </div>
            <div className="flex_profit_row">
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="tooltip-disabled">Generate PDF</Tooltip>}
              >
                <span
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    HandlePDFClick();
                  }}
                >
                  <IconFileTypePdf />
                </span>
              </OverlayTrigger>
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="tooltip-disabled">Edit</Tooltip>}
              >
                <a onClick={() => navigate(`/edit-rfq/${opportunity?.rfq_id}`)}>
                  <IconEdit />
                </a>
              </OverlayTrigger>
              {/* {["pre-paid", "post-paid"].includes(
                opportunity?.order_payment_type,
              ) && ( */}
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip id="tooltip-disabled">
                    {" "}
                    {opportunity?.customer_paid === "unpaid"
                      ? "Card Payment"
                      : "Payment Completed"}
                  </Tooltip>
                }
              >
                <span
                  onClick={openCardDetails}
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <IconCreditCardPay />
                </span>
              </OverlayTrigger>

              {/* {opportunity?.order_payment_type === "pre-paid" && opportunity?.customer_paid === "unpaid" && (
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip id="tooltip-disabled">Card Payment</Tooltip>
                  }
                >
                  <span onClick={openCardDetails}>
                    <IconCreditCardPay />
                  </span>
                </OverlayTrigger>
              )} */}
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="tooltip-disabled">Copy URL</Tooltip>}
              >
                <span onClick={handleShareClick}>
                  <IconShare />
                </span>
              </OverlayTrigger>
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="tooltip-disabled">Duplicate</Tooltip>}
              >
                <span
                  onClick={() => openModalCopy(opportunity)}

                  // onClick={() => {
                  //   setIsCopyQuoteOpen({
                  //     show: true,
                  //     rfq_id: opportunity?.rfq_id,
                  //     btnText: "Copy Opportunity",
                  //     label: "Opportunity",
                  //   });
                  // }}
                >
                  <IconCopyCheck />
                </span>
              </OverlayTrigger>
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="head_title">
            <h2>Opportunity ID: {opportunity?.rfq_id}</h2>
            <div className="status_dropdown" style={{ position: "relative" }}>
              <button
                onClick={() => setIsOpen(!isOpen)}
                style={{
                  backgroundColor: selected.color,
                }}
                disabled={
                  opportunity?.status === "WON" ||
                  opportunity?.status === "LOST" ||
                  opportunity?.status === "CANCELLED"
                }
              >
                {selected.label} <IconChevronDown />
              </button>
              {isOpen && (
                <div className="status_dropdown_select">
                  {statusOptions
                    // .filter((option) => option.value !== selected.value)
                    .filter((option) =>
                      STATUS_TRANSITIONS[
                        opportunity?.status || "DRAFT"
                      ].includes(option.value),
                    )
                    .map((option) => (
                      <div
                        className="status_options"
                        key={option.value}
                        onClick={() =>
                          openModal(
                            opportunity?.rfq_id,
                            option.value,
                            opportunity.status,
                          )
                        }
                        style={{
                          backgroundColor: option.color + "20",
                          cursor: "pointer",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            option.color + "33")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            option.color + "20")
                        }
                      >
                        {option.label}
                      </div>
                    ))}
                </div>
              )}
            </div>
            {/* {opportunity?.order_payment_type === "pre-paid" && (
              <Button
                className="ms-2"
                variant="warning"
                onClick={openCardDetails}
              >
                Authorize.net
              </Button>
            )} */}
          </div>
          <div className="head_mini_details">
            <div className="flex_profit_row">
              <p className="mb-0">
                <b className="profit_est">Date Created:</b> <IconCalendarWeek />{" "}
                {moment(opportunity?.created_at).format("MM/DD/YYYY")}
              </p>
              <p className="mb-0">
                <b className="profit_est">Contract vehicle:</b>{" "}
                {opportunity?.ContractType?.name || "N/A"}
              </p>
            </div>
            <div className="flex_profit_row">
              <p className="mb-0">
                <b className="profit_est">Sales Lead:</b> <IconUser />{" "}
                {opportunity?.sales_lead_name || "N/A"}
              </p>
              <p className="mb-0">
                <IconMail /> {opportunity?.sales_lead_email || "N/A"}
              </p>
              <p className="mb-0">
                <IconPhone />
                {opportunity?.sales_lead_phone || "N/A"}
              </p>
            </div>
          </div>
          <div className="full_details">
            <Row className="flex_rows">
              <Col lg={4} md={5} xs={5}>
                <p className="d-flex align-items-center gap-1">
                  <IconUser stroke={1} width={20} /> KO Name
                </p>
              </Col>{" "}
              <Col lg={8} md={7} xs={7}>
                <b>{opportunity?.rfqKo.name || "-"}</b>
              </Col>{" "}
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5} xs={5}>
                {" "}
                <p className="d-flex align-items-center gap-1">
                  <IconPhone stroke={1} width={20} /> Phone Number
                </p>
              </Col>{" "}
              <Col lg={8} md={7} xs={7}>
                <b>{opportunity?.rfqKo.phone || "-"}</b>
              </Col>
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5} xs={5}>
                {" "}
                <p className="d-flex align-items-center gap-1">
                  <IconMail stroke={1} width={20} /> Email ID
                </p>
              </Col>{" "}
              <Col lg={8} md={7} xs={7}>
                {opportunity?.rfqKo.email ? (
                  <span
                    onClick={(e) => {
                      setIsEmaillOpen({
                        title: "Contracting Officer's",
                        toName: opportunity?.rfqKo?.name,
                        show: true,
                        RFQID: opportunity.rfq_id,
                        toEmail: opportunity?.rfqKo?.email,
                        Quote_No: opportunity?.invoice_no,
                        defaultSubject: `${opportunity?.invoice_no}----(RFQ)`,
                        skuData: opportunity?.RfqProducts,
                        row: opportunity,
                      });
                    }}
                    className="text-decoration-underline"
                    style={{ cursor: "pointer" }}
                  >
                    <b>{opportunity?.rfqKo.email || "-"}</b>
                  </span>
                ) : (
                  <span className="empty_data">
                    <b>-</b>
                  </span>
                )}
              </Col>
            </Row>
            <Row className="flex_rows align-items-center mb-3">
              <Col lg={4} md={5} xs={5}>
                {" "}
                <p className="d-flex align-items-center gap-1 mb-0">
                  <IconMapPin stroke={1} width={20} /> Address
                </p>
              </Col>{" "}
              <Col lg={8} md={7} xs={7}>
                <b>{opportunity?.rfqKo.address || "-"}</b>
              </Col>
            </Row>
          </div>
          <div className="full_details">
            <Row className="flex_rows">
              <Col lg={4} md={5} xs={5}>
                <p className="d-flex align-items-center gap-1">
                  <IconUser stroke={1} width={20} /> Ship To
                </p>
              </Col>
              <Col lg={8} md={7} xs={7}>
                <b>{opportunity?.rfqShipping.name || "-"}</b>
              </Col>
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5} xs={5}>
                <p className="d-flex align-items-center gap-1">
                  <IconPhone stroke={1} width={20} /> Phone Number
                </p>
              </Col>{" "}
              <Col lg={8} md={7} xs={7}>
                <b>{opportunity?.rfqShipping.phone || "-"}</b>
              </Col>
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5} xs={5}>
                {" "}
                <p className="d-flex align-items-center gap-1">
                  <IconMail stroke={1} width={20} /> Email ID
                </p>
              </Col>{" "}
              <Col lg={8} md={7} xs={7}>
                {opportunity?.rfqShipping.email ? (
                  <span
                    onClick={(e) => {
                      setIsEmaillOpen({
                        title: "Customer Details",
                        toName: opportunity?.rfqShipping?.name,
                        show: true,
                        RFQID: opportunity.rfq_id,
                        toEmail: opportunity?.rfqShipping?.email,
                        Quote_No: opportunity?.invoice_no,
                        defaultSubject: `${opportunity?.invoice_no}----(RFQ)`,
                        skuData: opportunity?.RfqProducts,
                        row: opportunity,
                      });
                    }}
                    className="text-decoration-underline"
                    style={{ cursor: "pointer" }}
                  >
                    <b>{opportunity?.rfqShipping.email || "-"}</b>
                  </span>
                ) : (
                  <span className="empty_data">
                    <b>-</b>
                  </span>
                )}
              </Col>
            </Row>
            <Row className="flex_rows">
              <Col lg={4} md={5} xs={5}>
                <p className="d-flex align-items-center gap-1">
                  <IconMapPin stroke={1} width={20} /> Address
                </p>
              </Col>
              <Col lg={8} md={7} xs={7}>
                <b>{opportunity?.rfqShipping.address || "-"}</b>
              </Col>
            </Row>
          </div>

          <div className="attetchment_row">
            <p>
              <IconPaperclip stroke={1} width={20} />
              Attachments
              <span>({opportunity?.Attachments?.length})</span>
            </p>
            <div className="carousel-container">
              {opportunity?.Attachments &&
              opportunity?.Attachments.length > 0 ? (
                <>
                  <Swiper
                    slidesPerView={3}
                    spaceBetween={15}
                    loop={true}
                    navigation={true}
                    modules={[Navigation]}
                    className="mySwiper"
                  >
                    {opportunity?.Attachments.map((item, index) => {
                      const fileExtension = item.original_name
                        .split(".")
                        .pop()
                        .toLowerCase();

                      let fileIcon;
                      if (fileExtension === "pdf") {
                        fileIcon = (
                          <IconFileTypePdf
                            stroke={1}
                            width={45}
                            height={45}
                            style={{ color: "#D63939" }}
                          />
                        );
                      } else if (
                        [
                          "jpg",
                          "jpeg",
                          "png",
                          "gif",
                          "bmp",
                          "svg",
                          "webp",
                        ].includes(fileExtension)
                      ) {
                        fileIcon = (
                          <IconPhoto
                            stroke={1}
                            width={45}
                            height={45}
                            style={{ color: "#AE3EC9" }}
                          />
                        );
                      } else {
                        fileIcon = (
                          <IconFileTypeDoc
                            stroke={1}
                            width={45}
                            height={45}
                            style={{ color: "#4299E1" }}
                          />
                        );
                      }
                      return (
                        <SwiperSlide key={index} className="mySwiper">
                          <div className="card">
                            {item.type === "LINK" ? (
                              <a
                                href={item?.file_name}
                                target="_blank"
                                className="attetch_flex"
                              >
                                <IconLink
                                  stroke={1}
                                  width={45}
                                  height={45}
                                  style={{ color: "#4299E1" }}
                                />
                                <div className="attetch_info">
                                  <b>{item.original_name}</b>
                                  <p className="d-flex gap-3 mb-0">
                                    <span>LINK</span>
                                  </p>
                                </div>
                              </a>
                            ) : (
                              <div className="attetch_flex">
                                <div>{fileIcon}</div>
                                <div
                                  className="attetch_info"
                                  // onClick={(e) => {
                                  //   downloadImage(e, item.file_name);
                                  // }}
                                >
                                  <b>{item.original_name}</b>
                                  <p className="d-flex gap-3 mb-0">
                                    <span
                                      onClick={(e) => {
                                        viewAttachment(e, item?.id);
                                      }}
                                    >
                                      Download
                                    </span>
                                    <span
                                      className="text-blue"
                                      // href={`${IMG}uploads/attachments/${item.file_name}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      onClick={(e) => {
                                        viewAttachment(e, item?.id);
                                      }}
                                    >
                                      Preview
                                    </span>
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                </>
              ) : (
                <p>No Attachments available</p>
              )}
            </div>
          </div>

          <div className="tabs_details">
            <Tabs
              defaultActiveKey="General"
              id="uncontrolled-tab-example"
              className="mb-3"
            >
              <Tab eventKey="General" title={`General`}>
                <div className="full_details border-0 p-0">
                  <Row className="flex_rows">
                    <Col lg={4} md={5}>
                      <p className="d-flex align-items-center gap-1">
                        Opportunity Type:
                      </p>
                    </Col>{" "}
                    <Col lg={8} md={7}>
                      <b>
                        {opportunity?.opportunity_type === "RFQ"
                          ? "OPPORTUNITY"
                          : opportunity?.opportunity_type === "DIRECT_SALES"
                            ? "DIRECT SALES"
                            : opportunity?.opportunity_type}
                      </b>
                    </Col>{" "}
                  </Row>
                  {/* <Row className="flex_rows">
                    <Col lg={4} md={5}>
                      {" "}
                      <p className="d-flex align-items-center gap-1">
                        Opportunity Name:
                      </p>
                    </Col>{" "}
                    <Col lg={8} md={7}>
                      <b>{opportunity?.opportunity_name || "N/A"}</b>
                    </Col>
                  </Row> */}
                  <Row className="flex_rows">
                    <Col lg={4} md={5}>
                      {" "}
                      <p className="d-flex align-items-center gap-1">
                        Customer Name:
                      </p>
                    </Col>{" "}
                    <Col lg={8} md={7}>
                      <b>{opportunity?.organization_name || "N/A"}</b>
                    </Col>
                  </Row>
                  <Row className="flex_rows">
                    <Col lg={4} md={5}>
                      {" "}
                      <p className="d-flex align-items-center gap-1">
                        Valid For:
                      </p>
                    </Col>{" "}
                    <Col lg={8} md={7}>
                      <b>{opportunity?.valid_for || "N/A"} Days</b>
                    </Col>
                  </Row>
                  <Row className="flex_rows">
                    <Col lg={12} md={12}>
                      {" "}
                      <p>
                        <b className="d-block" style={{ color: "#000" }}>
                          Opportunity Description:{" "}
                        </b>
                        {opportunity?.brief || "N/A"}
                      </p>
                    </Col>{" "}
                  </Row>
                </div>
              </Tab>
              <Tab
                eventKey="Products"
                title={
                  <>
                    Products{" "}
                    <span className="badge bg-indigo-lt">
                      {opportunity?.RfqProducts?.length}
                    </span>
                  </>
                }
              >
                {opportunity?.RfqProducts.map((product) => (
                  <div key={product.id}>
                    <Card className="status_item_card w-100">
                      <Card.Body>
                        <div className="rfq_card_row">
                          <div className="rfq_item_card">
                            <div className="value_card">Vendor Name</div>
                            <p className="label_card">
                              {product.Vendor
                                ? product.Vendor.display_name
                                : "N/A"}
                            </p>
                          </div>
                          <div className="rfq_item_card">
                            <div className="value_card">SKU ID</div>
                            <p className="label_card">
                              {/* // changed from sku_id to sku_display_name */}
                              {product.sku_display_name || "N/A"}
                            </p>
                          </div>
                        </div>
                        <div className="rfq_card_row">
                          <div className="rfq_item_card">
                            <div className="value_card">Aspetto Cost</div>
                            <p className="label_card">
                              $
                              {product.aspetto_price
                                ? trimTrailingZeros(product.aspetto_price)
                                : "N/A"}
                            </p>
                          </div>
                          <div className="rfq_item_card">
                            <div className="value_card">Total Cost</div>
                            <p className="label_card">
                              $
                              {product.total_price
                                ? product.total_price
                                : "N/A"}
                            </p>
                          </div>
                        </div>
                        <div className="rfq_card_row mb-0">
                          <div className="rfq_item_card">
                            <div className="value_card">
                              Product Description
                            </div>
                            <p className="label_card mb-0">
                              {product.description ||
                                "No description available"}
                            </p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                ))}
              </Tab>
              <Tab
                eventKey="Notes"
                title={
                  <>
                    Notes{" "}
                    <span className="badge bg-indigo-lt">
                      {/* {opportunity.RfqNotes.length} */}
                      {totalNotes}
                    </span>
                  </>
                }
              >
                {opportunity?.section.length === 0 ? (
                  <div className="data_not_available text-center pb-4">
                    <Lottie animationData={notfoundData} />{" "}
                    <p>No notes available</p>
                  </div>
                ) : (
                  opportunity?.section.map((section) => (
                    <div key={section.id}>
                      {section.notes.length > 0
                        ? section.notes.map((note) => (
                            <Card
                              className="status_item_card w-100"
                              key={note.id}
                            >
                              <Card.Body>
                                <div className="flex_note_head mb-1">
                                  <span className="badge bg-indigo-lt">
                                    {section.name.charAt(0).toUpperCase() +
                                      section.name.slice(1)}
                                    .
                                  </span>
                                  <div className="note_info_time">
                                    <p className="note_user mb-0">
                                      <IconUserCircle /> {note.User.first_name}{" "}
                                      {note.User.last_name}
                                    </p>
                                    <p className="note_user mb-0">
                                      <IconClockHour3 />{" "}
                                      {moment(note.createdAt).format(
                                        "MM/DD/YYYY hh:mm A",
                                      )}
                                    </p>
                                  </div>
                                </div>
                                <p className="mb-0">{note.note}</p>
                              </Card.Body>
                            </Card>
                          ))
                        : null}
                    </div>
                  ))
                )}
              </Tab>
            </Tabs>
          </div>
          {isEmaillOpen.show && (
            <KOorCustomerEmailDialog
              pagetitle={isEmaillOpen.title}
              toEmail={isEmaillOpen.toEmail}
              toName={isEmaillOpen.toName}
              RFQID={isEmaillOpen.RFQID}
              show={isEmaillOpen.show}
              skuData={isEmaillOpen.skuData}
              row={isEmaillOpen.row}
              defaultSubject={isEmaillOpen.defaultSubject}
              Quote_No={isEmaillOpen.Quote_No}
              setShow={setIsEmaillOpen}
              setIsSuccsessModalOpen={setIsSuccsessModalOpen}
            />
          )}

          {/* {isCopyQuoteOpen.show && (
            <CopyOpportunityDialog
              module_id={isCopyQuoteOpen.rfq_id}
              show={isCopyQuoteOpen.show}
              onCopy={handleCopy_Quote}
              setShow={setIsCopyQuoteOpen}
            />
          )} */}
        </Offcanvas.Body>
      </Offcanvas>

      <ComanConfirmationModal
        show={isModalOpen.show}
        onHide={() => {
          setIsModalOpen({ ...isModalOpen, show: false });
          setIsOpen(false);
        }}
        title={isModalOpen.title}
        message={isModalOpen.message}
        onConfirm={isModalOpen.onConfirm}
        icon={isModalOpen.icon}
        type={isModalOpen.type}
      />
      <SuccsessMsgModal
        show={isSuccsessModalOpen.show}
        onHide={() =>
          setIsSuccsessModalOpen(
            { ...isSuccsessModalOpen, show: false },
            // navigate("/dashboard")
          )
        }
        onSecondaryBtnClick={() => {
          setIsModalOpen({ ...isModalOpen, show: false });
          navigate("/create-rfq");
        }}
        title={isSuccsessModalOpen?.title}
        btntext={isSuccsessModalOpen?.btntext}
        message={isSuccsessModalOpen?.message}
        newbtn={isSuccsessModalOpen?.newbtn}
      />
    </>
  );
}

export default View_DetailsOpportunity;
